var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['toggle-switch', { active: _vm.localActive }],on:{"click":_vm.toggle}},[_c('div',{staticClass:"toggle-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }